import React from "react";
import { motion } from "framer-motion";
import { BadgeDollarSign, ArrowUpRight } from "lucide-react";
import { RESULTS } from "../constants/content";
import { typeformLinkProps } from "./TypeformModal";

const ResultsSection = () => {
    return (
        <section id="results" data-testid="results-section" className="relative overflow-hidden py-28 sm:py-36">
            <div className="absolute inset-0 bg-gradient-to-b from-transparent via-neon-purple/[0.04] to-transparent" />
            <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
                <motion.p
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.6 }}
                    className="font-mono-tech text-[11px] uppercase tracking-[0.35em] text-neon-pink"
                >
                    Proof
                </motion.p>
                <motion.h2
                    initial={{ opacity: 0, y: 32 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.7, delay: 0.1 }}
                    className="font-display mt-5 text-3xl font-extrabold leading-tight text-white sm:text-5xl"
                >
                    Creator <span className="text-gradient-neon">results</span>
                </motion.h2>
                <motion.p
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.7, delay: 0.2 }}
                    className="mt-5 max-w-xl text-base text-white/70"
                >
                    Real revenue generated by creators using Fan Creator.
                </motion.p>

                <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
                    {RESULTS.map((r, i) => (
                        <motion.div
                            key={r.name + i}
                            initial={{ opacity: 0, y: 40 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-60px" }}
                            transition={{ duration: 0.55, delay: i * 0.1 }}
                            data-testid={`result-card-${i}`}
                            className="group overflow-hidden rounded-2xl border border-border bg-card/70 transition-colors duration-300 hover:border-neon-purple/50"
                        >
                            <div className="relative h-44 overflow-hidden">
                                {r.image ? (
                                    <img
                                        src={r.image}
                                        alt={r.name}
                                        loading="lazy"
                                        className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                                    />
                                ) : (
                                    <div className="flex h-full w-full items-center justify-center bg-gradient-to-br from-neon-purple/20 to-neon-pink/10">
                                        <BadgeDollarSign size={40} className="text-neon-blue" />
                                    </div>
                                )}
                                <div className="absolute inset-0 bg-gradient-to-t from-card to-transparent" />
                            </div>
                            <div className="p-6">
                                <p className="font-display text-2xl font-black text-gradient-neon sm:text-3xl">
                                    {r.stat}
                                </p>
                                <p className="mt-1 text-sm text-white/75">{r.label}</p>
                                <p className="mt-3 font-mono-tech text-[11px] uppercase tracking-[0.2em] text-white/40">
                                    {r.name}
                                </p>
                                <a
                                    {...typeformLinkProps}
                                    data-testid={`result-cta-${i}`}
                                    className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-neon-blue transition-colors hover:text-neon-pink"
                                >
                                    Learn more <ArrowUpRight size={15} />
                                </a>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ResultsSection;
